import { useState } from 'react'
import { useCases } from '@/hooks/useData'

export default function Cases() {
  const { data: casesData } = useCases()
  const [selectedCategory, setSelectedCategory] = useState<string>('')

  const filteredCases = selectedCategory
    ? casesData?.cases.filter(case_ => case_.category === selectedCategory)
    : casesData?.cases

  return (
    <div className="min-h-screen bg-white">
      {/* 页面标题 */}
      <section className="bg-gradient-to-r from-primary-600 to-primary-800 text-white py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold mb-4">工程案例</h1>
          <p className="text-xl text-primary-100">
            展示我们的专业能力和成功案例
          </p>
        </div>
      </section>

      {/* 案例分类筛选 */}
      <section className="py-8 bg-secondary-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-4 justify-center">
            <button
              onClick={() => setSelectedCategory('')}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                selectedCategory === ''
                  ? 'bg-primary-600 text-white'
                  : 'bg-white text-secondary-600 hover:bg-primary-50'
              }`}
            >
              全部案例
            </button>
            {casesData?.categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.name)}
                className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                  selectedCategory === category.name
                    ? 'bg-primary-600 text-white'
                    : 'bg-white text-secondary-600 hover:bg-primary-50'
                }`}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* 案例列表 */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredCases?.map((project) => (
              <div key={project.id} className="card">
                <img
                  src={project.images[0]}
                  alt={project.title}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <div className="mb-4">
                  <span className="px-2 py-1 bg-primary-100 text-primary-700 text-xs rounded">
                    {project.category}
                  </span>
                </div>
                <h3 className="text-lg font-semibold mb-2">{project.title}</h3>
                <p className="text-secondary-600 mb-4 line-clamp-3">
                  {project.description}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="text-sm text-secondary-500">
                    <strong>客户:</strong> {project.client}
                  </div>
                  <div className="text-sm text-secondary-500">
                    <strong>地点:</strong> {project.location}
                  </div>
                  <div className="text-sm text-secondary-500">
                    <strong>时间:</strong> {project.startDate} - {project.endDate}
                  </div>
                </div>
                <div className="mb-4">
                  <h4 className="font-semibold mb-2">技术方案:</h4>
                  <div className="flex flex-wrap gap-2">
                    {project.technologies.map((tech, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 bg-secondary-100 text-secondary-700 text-xs rounded"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="mb-4">
                  <h4 className="font-semibold mb-2">项目成果:</h4>
                  <p className="text-sm text-secondary-600">{project.results}</p>
                </div>
                <div className="border-t pt-4">
                  <h4 className="font-semibold mb-2">客户评价:</h4>
                  <p className="text-sm text-secondary-600 italic">
                    "{project.testimonial}"
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
} 